import Telemetry from '@atlassian/mpac-telemetry';
import { useEffect, useState } from 'react';
import { AppListingTask, viewAppDetailsTask } from '../telemetry/tasks';
import { isRuByPartnerAppAccessDeniedError } from '../utils';
/* When the status is 401, we redirect to login instead [MC-1770, MC-2339] */
const isAuthError = error => {
  return error.networkError && 'statusCode' in error.networkError && error.networkError.statusCode === 401;
};
export const useAppListingTelemetryTracking = (_data, error, networkStatus) => {
  const [fetching, setFetching] = useState(false);
  useEffect(() => {
    /**
     * When the page is SSR'd or the GraphQL result is served from cache,
     * the `networkStatus` and `data` field will both be immediately populated with `7` and
     * the cached data respectively. Since the task never gets started, the end becomes a no-op;
     * consequently the main app listing task never ends and we lose the metric.
     *
     * To counter this case we immediately start and end the task to track the metric for SLO.
     * But the caveat is that in these cases the "duration" of the task will be 0/negligible and
     * should be ignored.
     */
    const startImmediatelyIfNotStarted = () => {
      if (!fetching) {
        AppListingTask.start();
      }
    };
    const handleNetworkStatusLoading = () => {
      setFetching(true);
      AppListingTask.start();
    };
    const handleNetworkStatusReady = () => {
      startImmediatelyIfNotStarted();
      AppListingTask.succeeded();
      setFetching(false);
    };
    const handleNetworkStatusError = () => {
      startImmediatelyIfNotStarted();
      if (isAuthError(error) || isRuByPartnerAppAccessDeniedError(error)) {
        Telemetry.setUFOInteractionError({
          name: viewAppDetailsTask,
          errorMessage: error === null || error === void 0 ? void 0 : error.message
        });
        AppListingTask.abort();
      } else {
        Telemetry.setUFOInteractionError({
          name: viewAppDetailsTask,
          errorMessage: error === null || error === void 0 ? void 0 : error.message
        });
        AppListingTask.failed(error);
        setFetching(false);
      }
    };
    if (networkStatus === 1) {
      handleNetworkStatusLoading();
    } else if (networkStatus === 7) {
      handleNetworkStatusReady();
    } else if (networkStatus === 8) {
      handleNetworkStatusError();
    }
  }, [networkStatus]);
};